import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-grids";
import { Observable, Subject } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { onBoardingtemplateBO } from "./agreement-template.model";
@Injectable({
  providedIn: 'root'
})

export class AgreementTemplateService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService, public errorService: ErrorService) {
    super();
  }

  public executeClient(state: onBoardingtemplateBO): void {
    this.getTemplateListClient(state).subscribe(x => super.next(x));
  }
  getTemplateListClient(state?: onBoardingtemplateBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClientAgreement/GetClientTemplateListForAgency", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['totalCount']
          }
      ))
  }

  public executeEmployee(state: onBoardingtemplateBO): void {
    this.getTemplateListEmployee(state).subscribe(x => super.next(x));
  }

  getTemplateListEmployee(state?: onBoardingtemplateBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeeAgreement/GetEmployeeTemplateListForAgency", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['totalCount']
          }
      ))
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}
